/**
 * @file use-toast.ts
 * @description Toast 알림을 관리하는 커스텀 훅
 */

"use client";

import { useState, useCallback } from "react";

export type ToastType = "success" | "error";

interface Toast {
  id: string;
  message: string;
  type: ToastType;
}

let toastIdCounter = 0;

export function useToast() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const showToast = useCallback((message: string, type: ToastType) => {
    const id = `toast-${Date.now()}-${toastIdCounter++}`;
    setToasts((prev) => [...prev, { id, message, type }]);
  }, []);

  const removeToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const success = useCallback(
    (message: string) => {
      showToast(message, "success");
    },
    [showToast],
  );

  const error = useCallback(
    (message: string) => {
      showToast(message, "error");
    },
    [showToast],
  );

  return {
    toasts,
    success,
    error,
    removeToast,
  };
}

